import React from "react";

// VOCI DI IMPRESE — Logo in BORDEAUX #6E2A33
// Skyline edifici stilizzati + onda sonora + wordmark.
// Slot sostituibile: imposta REACT_APP_LOGO_URL nell'.env del frontend per usare il PNG ufficiale.
const BORDEAUX = "#6E2A33";

export const Logo = ({ size = 40, showWord = true, withTagline = true }) => {
    const customUrl = process.env.REACT_APP_LOGO_URL;
    return (
        <div className="flex items-center gap-3" data-testid="logo">
            {customUrl ? (
                <img src={customUrl} alt="Voci di Imprese — Podcast" style={{ height: size * 0.75, width: "auto" }} />
            ) : (
                <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    {/* Stylized buildings / skyline */}
                    <g fill={BORDEAUX}>
                        <rect x="8" y="28" width="6" height="24" />
                        <rect x="16" y="20" width="7" height="32" />
                        <rect x="25" y="12" width="8" height="40" />
                        <rect x="35" y="22" width="7" height="30" />
                        <rect x="44" y="30" width="6" height="22" />
                        <rect x="52" y="34" width="5" height="18" />
                        {/* Building windows hint */}
                        <rect x="27" y="18" width="2" height="2" fill="#FFFFFF" />
                        <rect x="30" y="22" width="2" height="2" fill="#FFFFFF" />
                        <rect x="17.5" y="26" width="2" height="2" fill="#FFFFFF" />
                        <rect x="20" y="32" width="2" height="2" fill="#FFFFFF" />
                        <rect x="37" y="28" width="2" height="2" fill="#FFFFFF" />
                        <rect x="40" y="34" width="2" height="2" fill="#FFFFFF" />
                    </g>
                    {/* Ground line */}
                    <rect x="4" y="52" width="56" height="2" fill={BORDEAUX} />
                    {/* Soundwave above buildings */}
                    <g stroke={BORDEAUX} strokeWidth="2" strokeLinecap="round" fill="none">
                        <path d="M 8 8 Q 14 4 20 8 T 32 8 T 44 8 T 56 8" opacity="0.9" />
                        <circle cx="8" cy="8" r="1.5" fill={BORDEAUX} />
                        <circle cx="56" cy="8" r="1.5" fill={BORDEAUX} />
                    </g>
                </svg>
            )}
            {showWord && !customUrl && (
                <div className="leading-tight">
                    <div className="font-heading text-lg font-semibold tracking-wider uppercase" style={{ color: BORDEAUX }}>Voci di Imprese</div>
                    {withTagline && <div className="text-[10px] font-body tracking-[0.3em] text-muted uppercase">Podcast · Network</div>}
                </div>
            )}
        </div>
    );
};
